import { useCallback, useMemo } from 'react'
import LazyHydrate from 'react-lazy-hydration'
import { CircleCloseIcon } from '@/atoms/Icons/CircleCloseIcon'
import { Modal } from '@/molecules/Modal'
import { AngelPlayer, createAsset } from '@/organisms/AngelPlayer'

interface AngelTorchVideoModalProps {
  torchVideoUrl: string
  handleClose: () => void
  showModal: boolean
}

export const AngelTorchVideoModal: React.FC<AngelTorchVideoModalProps> = ({
  torchVideoUrl,
  handleClose,
  showModal,
}) => {
  const handleModalClose = useCallback(() => {
    handleClose()
  }, [handleClose])

  const asset = useMemo(() => {
    return createAsset({
      url: torchVideoUrl,
      guid: `torch-${torchVideoUrl}`,
      name: `Torch Explainer Video`,
      slug: `create`,
      videoType: 'pif-explainer',
      subtitle: `Torch Video`,
      title: ``,
    })
  }, [torchVideoUrl])

  return (
    <div>
      <Modal
        isOpen={showModal}
        onClose={handleModalClose}
        panelClasses="min-w-[80vw] lg:min-w-[55vw] !bg-transparent !p-0 !shadow-none"
      >
        <div className="relative overflow-hidden rounded-xl">
          <LazyHydrate whenVisible>
            <AngelPlayer asset={asset} className="relative w-full" shouldSaveWatchPosition={false} autoplay />
          </LazyHydrate>
          <div
            className="absolute right-2 top-2 z-[10000000] h-8 w-8 cursor-pointer rounded-full bg-transparent transition-all duration-300 ease-in-out hover:opacity-80 md:right-4 md:top-6"
            onClick={handleModalClose}
          >
            <CircleCloseIcon color="core-gray-100" size={32} className="cursor-pointer" />
          </div>
        </div>
      </Modal>
    </div>
  )
}

AngelTorchVideoModal.displayName = 'React.memo(AngelTorchVideoModal)'
